export default __webpack_public_path__ + "static/media/home_newcolor.bf132314.png";